import React from 'react';
import Dropdown from 'components/shared/Dropdown/Dropdown';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import classNames from 'classnames';
import { NE_TYPES, DELETE_TOOLTIP } from '../utils';
import styles from './ProvisionTable.module.css';

const ProvisionTable = ({ data, defaultValues, deletingSuId, setIsDeleteSuModalOpen, setValue }) => {
  const handleChange = (id, field, value) => {
    const newData = data.map((item) => {
      if (item.id === id) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setValue('state.data', newData);
  };

  const handleDeleteSuOnClick = (suId) => {
    if (!suId || isNaN(suId)) return;

    setIsDeleteSuModalOpen(true);
    deletingSuId.current = suId;
  };

  const enableRow = (item) => item.device || item.neType;

  const areIdsAndTypesMatched = (prevData, curData) =>
    enableRow(curData) && prevData?.device === curData?.device && prevData?.neType === curData?.neType;

  return (
    <div className={styles.root}>
      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr className={styles.tr}>
            <th>Sector</th>
            <th>Device</th>
            <th>NE-Type</th>
            <th>Ops Status</th>
            <th>SW Baseline</th>
          </tr>
        </thead>
        <tbody className={styles.tbody}>
          {data?.map((item, idx) => {
            const isRowEnabled = enableRow(item);
            const isMatched = areIdsAndTypesMatched(defaultValues.state.data[idx], item);
            const isOpStateEnabled = item.operationalState === 'enabled';
            const isDeleteEnabled = isMatched && !isOpStateEnabled;
            const deleteIcon = isDeleteEnabled
              ? IconLoader.icon_chartset_delete
              : IconLoader.icon_chartset_delete_disabled;
            const deleteHoverIcon = isDeleteEnabled
              ? IconLoader.icon_chartset_delete_hover
              : IconLoader.icon_chartset_delete_disabled;

            return (
              <tr key={item.id} className={classNames(!isRowEnabled && styles.emptyContentTr)}>
                <td className={styles.td}>{item.id}</td>
                <td>
                  <div className={styles.inputContainer}>
                    <SvgAF img={IconLoader.icon_service} />
                    <input
                      aria-label="Serial id"
                      className={styles.input}
                      type="text"
                      value={item.device}
                      onChange={(e) => handleChange(item.id, 'device', e.target.value)}
                    />
                  </div>
                </td>
                <td>
                  <Dropdown
                    hideArrow={false}
                    disabled={false}
                    sendId={(value) => handleChange(item.id, 'neType', value)}
                    title={item.neType || 'Type'}
                    data={NE_TYPES}
                    ids={NE_TYPES}
                  />
                </td>
                <td className={styles.rowVal}>{item.operationalState}</td>
                <td className={styles.rowVal}>{item.baseline}</td>
                <td className={styles.deleteBtn}>
                  <SvgAF
                    role="button"
                    aria-label="Delete"
                    img={deleteIcon}
                    hover={deleteHoverIcon}
                    onClick={() => isDeleteEnabled && handleDeleteSuOnClick(item.id)}
                    tooltip={isOpStateEnabled ? DELETE_TOOLTIP : 'Delete'}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ProvisionTable;
